/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader, ModalTab } from '../../../../components/Modal';
import TaxInvoiceListModal from './TaxInvoiceListModal';
import TradeInvoiceListModal from './TradeInvoiceListModal';
import CardTransListModal from './CardTransListModal';
import CashReceiptsListModal from './CashReceiptListModal';
import { isEmpty } from 'lodash';
import DataComponent from '../../../../components/DataComponent';
import { classnames } from '../../../../utils/text';

const tabKeyList = ["TAX_INVOICE", "TRADE_INVOICE", "CASH_INVOICE", "FUND_CARD_HISTORY"];

const BankRelatedModal = ({
  open,
  setOpen,
  bankData,
  submit,
  permissions,
  fields = []
}) => {
  const [activeTab, setActiveTab] = useState(null);
  const [tabList, setTabList] = useState([]);


  useEffect(() => {
    if (!isEmpty(permissions)) {
      // const transPermissions = bankData[0].inAmt > 0 ? permissions : permissions.filter(p => p.code !== 'FUND_CARD_HISTORY');
      const transTabKeyList = bankData[0].inAmt > 0 ? tabKeyList : tabKeyList.filter(p => p !== 'FUND_CARD_HISTORY');
      setActiveTab(transTabKeyList[0]);

      setTabList(
        transTabKeyList.map(tab => {
          const p = permissions.find(f => f.code === tab);
          return {
            label: p.name,
            value: p.code,
            action: setActiveTab
          };
        })
      );

      if (!open) {
        // setActiveTab(transPermissions[0].code);
        setActiveTab(transTabKeyList[0]);
      }
    }
  }, [permissions, open]);

  const cancel = () => {
    setOpen(false);
  };

  return (
    <Modal isOpen={open} close={cancel} size="xx-lg">
      <div className="bank-trans-related-list-modal">
        <ModalHeader>관련항목 추가</ModalHeader>
        {!isEmpty(fields) && !isEmpty(bankData) && (
          <div className="bank-summaries-detail">
            <table className="bank-detail-table">
              <thead>
                <tr>
                  {fields[0].map((field, idx) => <th key={idx}>{field.title}</th>)}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {fields[0].map((field, idx) => (
                    <td key={idx} className={classnames("vertical-align-middle", field.className)}>
                      <DataComponent field={field} form={bankData[0]} data={bankData[0]} />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>

            <table className="bank-detail-table mt-10">
              <thead>
                <tr>
                  {!isEmpty(fields) &&
                    fields[1].map((field, idx) => <th key={idx}>{field.title}</th>)}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {fields[1].map((field, idx) => (
                    <td key={idx} className={classnames("vertical-align-middle", field.className)}>
                      <DataComponent field={field} form={bankData[0]} data={bankData[0]} />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

        )}
        <ModalTab tabList={tabList} active={activeTab} />
        {activeTab === 'TAX_INVOICE' && <TaxInvoiceListModal open={open} setOpen={setOpen} bankData={bankData} detailSubmit={submit} />}
        {activeTab === 'TRADE_INVOICE' && <TradeInvoiceListModal open={open} setOpen={setOpen} bankData={bankData} detailSubmit={submit} />}
        {activeTab === 'CASH_INVOICE' && <CashReceiptsListModal open={open} setOpen={setOpen} bankData={bankData} detailSubmit={submit} />}
        {activeTab === 'FUND_CARD_HISTORY' && <CardTransListModal open={open} setOpen={setOpen} bankData={bankData} detailSubmit={submit} />}
      </div>
    </Modal>
  );
};

export default BankRelatedModal;